import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule, NgOptimizedImage } from "@angular/common";
import { RouterModule } from "@angular/router";
import { WidgetsModule } from "../widgets/widgets.module";
import { TranslateModule } from "@ngx-translate/core";
import { AccessRouteModule } from "./access-routes";
import { AccountService } from "../shared/services/account.service";
import { LoginComponent } from "./login/login.component";
import { LogoutComponent } from "./logout.component";
import { RequestPasswordComponent } from "./request-password/request-password.component";
import { CompleteRegisterComponent } from "./complete-register/complete-register.component";
import { CoachUpdatePasswordComponent } from "./coach-update-password/coach-update-password.component";
import { MfaLoginComponent } from "./login/mfa-login/mfa-login.component";
import { TopNavModule } from "../top-nav/top-nav.module";
import { ChooseAdventureComponent } from "./choose-adventure/choose-adventure.component";
import { CountdownComponent } from "./countdown/countdown.component";
import { ProvisioningService } from "app/shared/services/provisioning.service";

// Angular Material Modules
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatDialogModule } from "@angular/material/dialog";
import {
  UIComponentsModule,
  CPasswordStrengthIndicatorComponent,
  CButtonStyleComponent,
} from "@cariloop/ui-components";
import { MobileAppCtaComponent } from "./login/mobile-app-cta/mobile-app-cta.component";
import { CtaMobileComponent } from "./login/cta-mobile/cta-mobile.component";
import { SuccessContainerComponent } from "../widgets/success-container/success-container.component";

@NgModule({
  imports: [
    TranslateModule.forChild(),
    CommonModule,
    RouterModule,
    AccessRouteModule,
    FormsModule,
    WidgetsModule,
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    TopNavModule,
    MatDialogModule,
    UIComponentsModule,
    CPasswordStrengthIndicatorComponent,
    SuccessContainerComponent,
    CButtonStyleComponent,
  ],
  declarations: [
    LoginComponent,
    LogoutComponent,
    RequestPasswordComponent,
    CompleteRegisterComponent,
    CoachUpdatePasswordComponent,
    CountdownComponent,
    ChooseAdventureComponent,
    MfaLoginComponent,
    MobileAppCtaComponent,
    CtaMobileComponent,
  ],
  exports: [
    LoginComponent,
    LogoutComponent,
    RequestPasswordComponent,
    CompleteRegisterComponent,
  ],
  providers: [AccountService, ProvisioningService],
})
export class AccessModule {}
